import { API_URL } from '../../../app-config/constants';
import { remove as deleteRequest, get, post, put } from '../request';

const GLOSSARY = `${API_URL}/glossary`;

export type GlossaryTerm = {
    id: string;
    keyword: string;
    explanation: string;
};

export type CreateGlossaryTermRequest = {
    keyword: string;
    explanation: string;
};

getAll.operation = 'READ';
export function getAll() {
    return get<GlossaryTerm[]>(GLOSSARY);
}

export function getAllWithoutCache() {
    return get<GlossaryTerm[]>(GLOSSARY);
}

getAllForAdmin.operation = 'READ';
export function getAllForAdmin() {
    return get<GlossaryTerm[]>(`${GLOSSARY}/admin`);
}

const getterFunctions = [getAll.name, getAllForAdmin.name];

create.operation = 'CREATE';
create.invalidates = getterFunctions;
export function create(term: CreateGlossaryTermRequest) {
    return post<GlossaryTerm>(GLOSSARY, { postData: term });
}

// TODO: enable when Ladda supports array-creates
// bulkCreate.operation = 'CREATE';
bulkCreate.invalidates = getterFunctions;
export function bulkCreate(terms: CreateGlossaryTermRequest[]) {
    return post<GlossaryTerm[]>(`${GLOSSARY}/bulk`, { postData: { terms } });
}

update.operation = 'UPDATE';
update.invalidates = getterFunctions;
export function update(term: GlossaryTerm) {
    return put<GlossaryTerm>(`${GLOSSARY}/${term.id}`, { postData: term });
}

remove.operation = 'DELETE';
remove.invalidates = getterFunctions;
export function remove(id: string) {
    return deleteRequest(`${GLOSSARY}/${id}`);
}
